
export const VERSION = '5.8.8'; // Update this manually on each release


